var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24884 4.00125H4.49884V7.00125L6.87384 8.42625L7.24884 7.81125L5.24884 6.62625V4.00125ZM7.66734 0.90625L9.97085 2.82875L9.33084 3.59625L7.02585 1.67475L7.66734 0.90625ZM2.33034 0.90625L2.97134 1.67425L0.667344 3.59625L0.0273438 2.82825L2.33034 0.90625ZM4.99884 2.00125C2.51384 2.00125 0.498844 4.01625 0.498844 6.50125C0.498844 8.98625 2.51384 11.0013 4.99884 11.0013C7.48384 11.0013 9.49885 8.98625 9.49885 6.50125C9.49885 4.01625 7.48384 2.00125 4.99884 2.00125ZM4.99884 10.0013C3.06884 10.0013 1.49884 8.43125 1.49884 6.50125C1.49884 4.57125 3.06884 3.00125 4.99884 3.00125C6.92884 3.00125 8.49885 4.57125 8.49885 6.50125C8.49885 8.43125 6.92884 10.0013 4.99884 10.0013Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.096293c6e666afcbe721f0207f7f8e8b.svg";
export { ForwardRef as ReactComponent };